import { axios } from "../utils/request";

// 1.5.1.1 获取社群信息（根据token获取自己的社群信息）
export function getUserCommunityInfoVoByToken(data) {
  return axios({
    url: '/h5UserCommunity/getUserCommunityInfoVoByToken',
    method: 'post',
    data
  })
}

// 1.5.1.2 获取社群信息（根据userId获取下级的社群信息）
export function getUserCommunityInfoVoById(data) {
  return axios({
    url: '/h5UserCommunity/getUserCommunityInfoVoById',
    method:'post',
    data
  })
}

// 1.5.1.3 分页获取社群人员列表（根据token获取自己的社群信息）
export function getUserCommunityListVoByPageByToken(data) {
  return axios({
    url: '/h5UserCommunity/getUserCommunityListVoByPageByToken',
    method: 'post',
    data
  })
}

// 1.5.1.4 分页获取社群人员列表（根据userId获取下级的社群信息）
export function getUserCommunityListVoByPageByUserId(data) {
  return axios({
    url: '/h5UserCommunity/getUserCommunityListVoByPageByUserId',
    method: 'post',
    data
  })
}

